module.exports = __webpack_public_path__ + "media/images/recover_data1-1967d771b622c2d189f1af53a3821087.png";